module.exports = __webpack_public_path__ + "img/img04.8fdca2a9.png";